import { render, staticRenderFns } from "./bpb-link-copier.vue?vue&type=template&id=cc7a6870&"
import script from "./bpb-link-copier.vue?vue&type=script&lang=js&"
export * from "./bpb-link-copier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports